module.exports = __webpack_public_path__ + "img/logo.22253c42.svg";